export enum LevumiItemCategory {
  ARGUMENT = 'Auslassung des Arguments',
  PREDICATE = 'Auslassung des Prädikats',
  CONNECTIVES = 'Auslassung der Konnektiva',

  // Keys prefixed with N6_ are used for the subCategories of N6 ('MAIN_CATEGORY - SUB_CATEGORY')
  N6_KOMPLEXE_NEBENSAETZE_SCHACHTENSAEZTE = 'Komplexe Nebensätze - Schachtensätze',
  N6_KOMPLEXE_NEBENSAETZE_KONZESSIVSAETZE = 'Komplexe Nebensätze - Konzessivsätze',

  N6_INFERENZBILDUNG_PRONOMEN = 'Inferenzbildung - Pronomen',
  N6_INFERENZBILDUNG_LEXIKALISCHE_REFERENZEN = 'Inferenzbildung - Lexikalische Referenzen',

  N6_KOHAERENZBILDUNG_KAUSALE_KOHAERENZ = 'Kohärenzbildung - Kausale Kohärenz',
  N6_KOHAERENZBILDUNG_TEMPORALE_KOHAERENZ = 'Kohärenzbildung - Temporale Kohärenz',
  N6_KOHAERENZBILDUNG_OERTLICHE_KOHAERENZ = 'Kohärenzbildung - Örtliche Kohärenz',
}

export enum LevumiSubject {
  GERMAN = 'german',
  MATH = 'math',
  NUMBER_DICTATION = 'number_dictation',
}

export enum LevumiMathCategory {
  SUB = 'Subtraktion',
  ADD = 'Addition',
  MUL = 'Multiplikation',
  DIV = 'Division',
}
